export default __webpack_public_path__ + "static/media/profile.f292cc85.png";